import type { SVGProps } from 'react';

const Evaluation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.125 2.5V11.875C3.125 12.3723 3.32254 12.8492 3.67417 13.2008C4.02581 13.5525 4.50272 13.75 5 13.75H6.875M3.125 2.5H1.875M3.125 2.5H16.875M6.875 13.75H13.125M6.875 13.75L6.04167 16.25M16.875 2.5H18.125M16.875 2.5V11.875C16.875 12.3723 16.6775 12.8492 16.3258 13.2008C15.9742 13.5525 15.4973 13.75 15 13.75H13.125M13.125 13.75L13.9583 16.25M6.04167 16.25H13.9583M6.04167 16.25L5.625 17.5M13.9583 16.25L14.375 17.5M6.25 10L8.75 7.5L10.54 9.29C11.381 8.08275 12.4768 7.07485 13.75 6.3375"
      stroke="#111927"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default Evaluation;
